module.exports = __webpack_public_path__ + "img/home-rbn-2.bc0af985.png";